import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  points_for_wholesaler: string().required("points for wholesaler is required"),
  points_for_retailer: string().required("points for retailer is required"),
  points_for_ryder: string().required("points for ryder is required"),
});

export const EditAgentsGlobalSettings = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      points_for_wholesaler: "",
      points_for_retailer: "",
      points_for_ryder: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          points_for_wholesaler: Number(values.points_for_wholesaler),
          points_for_retailer: Number(values.points_for_retailer),
          points_for_ryder: Number(values.points_for_ryder),
        };

        const response = await axiosInstance.put(
          `/admin/agent-points/${id}/`,
          payload
        );
        if (response.data) {
          toast.success("Agents Global Setting updated successfully!");
          setTimeout(() => navigate("/agents-global-setting"), 1500);
        } else {
          toast.error("Failed to update Agents Global Setting.");
        }
      } catch (err) {
        console.error("❌ Error updating Agents Global Setting:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/agents-global-setting");
  };

  useEffect(() => {
    const fetchAgentsGlobalSettingDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/agent-points/`);

        if (res.data?.status === "success" && res.data?.data) {
          const data = res.data.data;
          formik.setValues({
            points_for_wholesaler: data.points_for_wholesaler?.toString() || "",
            points_for_retailer: data.points_for_retailer?.toString() || "",
            points_for_ryder: data.points_for_ryder?.toString() || "",
          });
        } else {
          toast.error("Failed to load Agents Global Setting details.");
        }
      } catch (err) {
        console.error("❌ Error fetching Agents Global Setting data:", err);
        toast.error(
          "Something went wrong while loading Agents Global Setting data."
        );
      }
    };

    fetchAgentsGlobalSettingDetails();
  }, [id]);

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/agents-global-setting");
          }}
        />
        <div className="add-title">Edit Agents Global Setting</div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Points For Wholesaler
              </label>
              <div>
                <input
                  type="text"
                  name="points_for_wholesaler"
                  placeholder="Enter Your points for wholesaler"
                  value={formik.values.points_for_wholesaler}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.points_for_wholesaler &&
                  formik.errors.points_for_wholesaler && (
                    <div className="text-danger">
                      {formik.errors.points_for_wholesaler}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Points For Retailer
              </label>
              <div>
                <input
                  type="text"
                  name="points_for_retailer"
                  placeholder="Enter Your far points for retailer"
                  value={formik.values.points_for_retailer}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.points_for_retailer &&
                  formik.errors.points_for_retailer && (
                    <div className="text-danger">
                      {formik.errors.points_for_retailer}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Points For Ryder
              </label>
              <div>
                <input
                  type="text"
                  name="points_for_ryder"
                  placeholder="Enter Your snap points for ryder"
                  value={formik.values.points_for_ryder}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.points_for_ryder &&
                  formik.errors.points_for_ryder && (
                    <div className="text-danger">
                      {formik.errors.points_for_ryder}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave">Update</button>
          </div>
        </div>
      </form>
    </div>
  );
};
